import { render, staticRenderFns } from "./fspiDetail.vue?vue&type=template&id=da6d8668&scoped=true"
import script from "./fspiDetail.vue?vue&type=script&lang=js"
export * from "./fspiDetail.vue?vue&type=script&lang=js"
import style0 from "./fspiDetail.vue?vue&type=style&index=0&id=da6d8668&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da6d8668",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/devjobs/builds/JYRJr4p_y/0/supplyonline/covisint-cn-mcd/srm/mcd-srm-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('da6d8668')) {
      api.createRecord('da6d8668', component.options)
    } else {
      api.reload('da6d8668', component.options)
    }
    module.hot.accept("./fspiDetail.vue?vue&type=template&id=da6d8668&scoped=true", function () {
      api.rerender('da6d8668', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/QSPI/FSPI/fspiDetail.vue"
export default component.exports